import { Component ,ElementRef} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdleService } from './services/idle.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonPatternsService } from './common-patterns.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'admindashboard';
  loginform: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  });
  showPassword: string = 'password';
  fafaEye: string = 'fa fa-eye-slash';
  submitted = false;
  signinResults: any;

  constructor(
    private elementRef: ElementRef,  
    public  _router: Router, 
    private idleService: IdleService,
    private formBuilder: FormBuilder,
    private commonPatternsService: CommonPatternsService,
    private http: HttpClient,
  ) { }

    ngOnInit() {
      $('#session-timeout-login').hide();
      this.loginform = this.formBuilder.group({
        username: [ '', 
          [
            Validators.required,
            Validators.pattern(this.commonPatternsService.emailPattern),
          ],
        ],
        password: [ '', 
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
          ],
        ],

      }
    );
    // alert(this._router.url)
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(this._router.url)
        if (this._router.url != '/login') {
          // sessionStorage.clear();

          // this.idleService.startMonitoring(); // Start the timer after login or route change
        }
      }
    });
    
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s);
    if(sessionStorage.getItem("language")){

    }
    else{
      sessionStorage.setItem("language","English")
    }
  }
  // modalForm(){
  //   this.dialog.open(CreateDialogFormComponent);
  // }

  get f(): { [key: string]: AbstractControl } {
    return this.loginform.controls;
  }

  togglePasswordVisibility() {
    this.showPassword = (this.showPassword === "password") ? "text" : "password";
    this.fafaEye = (this.fafaEye === "fa fa-eye-slash") ? "fa fa-eye" : "fa fa-eye-slash";
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.loginform.invalid) {
      return;
    }

    let accessToken = sessionStorage.getItem('accessToken')
    this.http.post('http://[::1]:3002/api/ap/delete-session',{
      sessionId:accessToken,
      action:'Session Timeout'
    }).subscribe((response:any)=>{
      console.log(response)
      if(response.status === 200 || response.status === '200'){
        var endPoint = "/api/ap/auth/signin";
        var loginPostRequestBody = {
          "email": this.loginform.value.username.trim(),
          "password": this.loginform.value.password.trim()
        }

        this.http.post(environment.apiUrl + endPoint, loginPostRequestBody).subscribe(async (response: any) => {
          if (response["status"] == 200 || response["statusCode"] == 200) {

            this.signinResults = response.data

            console.log(this.signinResults)
            sessionStorage.setItem("signinResults", JSON.stringify(response.data));

            sessionStorage.setItem("accessToken", response["token"]);
            sessionStorage.setItem("loginname", this.loginform.value.username);
            sessionStorage.setItem("adminName", response.data.userName);
            sessionStorage.setItem("role", response.data.role);
            sessionStorage.setItem("language", "English");
            if (response && response.settings && response.settings.length > 0) {
              sessionStorage.setItem("fileSize", response.settings[0].settingsValue);
            }

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((response) => { })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((response) => { })
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((response) => { })
            $('#session-timeout-login').hide();
            $('#session-timeout-login').removeClass('show');
            // this.idleService.startMonitoring();

            this.http.post('http://[::1]:3002/api/ap/create-session',{
              role:response.data.role,
              portal:'Admin',
              sessionId:response["token"],
            }).subscribe((response:any)=>{
              console.log(response)
              if(response.status === 200 || response.status === '200'){
                setTimeout(() => {
                  // this._router.navigate(['/dashboard']);
                  this.idleService.startMonitoring();
                }, 1000);
              } else{
                Swal.fire({
                  title:"Error",
                  text:response.message
                })
                this._router.navigate(['/login'])
              }
            })
            
          }
          else if (response["status"] == 206 || response["statusCode"] == 206) {
            $("#activationlink").show()

            // Swal.fire({title:'Alert',text:"Please Contact System admin"})
            // $("#activationlink").show()
          }
          else if (response["status"] == 400 || response["statusCode"] == 400) {
            // alert("Invalid Details")
            // this.toastrService.error('Invalid Credentials', 'Error!');
            Swal.fire({ title: 'Error', text: response.message })
          }
          else {
            // alert("Invalid Details")
            Swal.fire({ title: 'Error', text: response.message })
          }
        }, (error) => {
          Swal.fire({ title: 'Error', text: "Invalid Credentials" })
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
      }else{
        Swal.fire({title:'Error',text:response.message})
        // sessionStorage.clear()
        this._router.navigate(['/login'])
      }
    })
  }
}
